import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const SubjectDropdownWithCreate = ({ curriculumId, gradeId, value, onChange }) => {
  const [subjects, setSubjects] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newName, setNewName] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (gradeId) fetchSubjects();
    else setSubjects([]);
  }, [gradeId]);

  const fetchSubjects = async () => {
    const res = await api.get(`/subjects/${gradeId}`);
    setSubjects(res.data);
  };

  const handleCreate = async () => {
    if (!newName.trim() || !curriculumId || !gradeId) return;
    setLoading(true);
    const res = await api.post('/subjects', { name: newName, curriculum: curriculumId, grade: gradeId });
    setNewName('');
    setShowModal(false);
    await fetchSubjects();
    onChange(res.data._id);
    setLoading(false);
  };

  return (
    <div className="mb-4">
      <label className="block text-sm font-semibold mb-1">Subject</label>
      <div className="flex gap-2 items-center">
        <select
          className="rounded px-3 py-2 bg-eduvibe-blue text-white focus:outline-none"
          value={value}
          onChange={e => onChange(e.target.value)}
          disabled={!curriculumId || !gradeId}
        >
          <option value="">{curriculumId && gradeId ? 'Select subject' : 'Select curriculum and grade first'}</option>
          {subjects.map(s => (
            <option key={s._id} value={s._id}>{s.name}</option>
          ))}
        </select>
        <button
          className="bg-eduvibe-green text-eduvibe-dark px-2 py-1 rounded hover:bg-eduvibe-green-dark font-bold text-lg"
          type="button"
          onClick={() => setShowModal(true)}
          disabled={!curriculumId || !gradeId}
          title="Add subject"
        >+
        </button>
      </div>
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-eduvibe-blue p-6 rounded-lg min-w-[300px]">
            <h2 className="text-lg font-bold mb-2 text-white">Add Subject</h2>
            <input
              className="w-full px-3 py-2 rounded mb-3 bg-eduvibe-dark text-white"
              placeholder="Subject name"
              value={newName}
              onChange={e => setNewName(e.target.value)}
              autoFocus
              disabled={loading}
            />
            <div className="flex gap-2 justify-end">
              <button onClick={() => setShowModal(false)} className="px-3 py-1 rounded bg-gray-600 text-white">Cancel</button>
              <button onClick={handleCreate} disabled={loading} className="px-3 py-1 rounded bg-eduvibe-green text-eduvibe-dark font-semibold hover:bg-eduvibe-green-dark">Create</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubjectDropdownWithCreate;
